export default class Modal {
    constructor() {
        this.init();
    }

    init() {
        this.eventBind();
    }

    resetEvent() {
        this.eventBind("reset");
    }

    eventBind(resetOption) {
        const openbuttons = [...document.querySelectorAll(".js-modal_open")];
        const closebuttons = [...document.querySelectorAll(".js-modal_close")];

        const handleOpen = (e) => {
            e.preventDefault();
            const modalID = e.currentTarget.getAttribute("data-modalID");
            const tgtmodal = document.querySelector(`.js-modal[data-modalID="${modalID}"]`);
            document.body.classList.add("-lock");
            tgtmodal && tgtmodal.classList.add("-active");
        };

        const handleClose = (e) => {
            e.preventDefault();
            const parentModal = e.currentTarget.closest(".js-modal");
            if (parentModal) {
                parentModal.classList.remove("-active");
                const activeModals = document.querySelectorAll(".js-modal.-active");
                if (activeModals.length === 0) {
                    document.body.classList.remove("-lock"); // 全てのモーダルが閉じたらスクロールを解除
                }
            }
        };

        openbuttons.forEach((el) => {
            resetOption && el.removeEventListener("click", handleOpen);
            el.addEventListener("click", handleOpen);
        });

        closebuttons.forEach((el) => {
            resetOption && el.removeEventListener("click", handleClose);
            el.addEventListener("click", handleClose);
        });
    }
}